import { Reveal } from "@/components/bits";
import PreorderCta from "@/components/store/PreorderCta";
import { POGO_COLOURS } from "@/config/pogoConfig";

const PAINS = [
  "Twelve hours on hard floors.",
  "Wet patches. Spills. Mystery liquids.",
  "Feet that give up before you do.",
  "Work shoes that are practical but ugly — or cute but useless.",
];

// Pain — soft pink tint band; empathetic tone, gentle handoff from the
// ivory hero. Acknowledge their shift first, then bridge into POSSO.
export default function ProblemStore() {
  return (
    <section data-testid="store-problem" className="bg-[#FF6BAA]/10 text-ink">
      <div className="px-4 py-12 sm:py-16 max-w-2xl mx-auto w-full">
        <Reveal>
          <p className="font-body font-bold text-[11px] tracking-[0.22em] uppercase text-ink/50">
            THE REALITY
          </p>
          <h2 className="mt-3 font-display uppercase leading-[0.95] text-[10.5vw] sm:text-5xl">
            Your shift is <span className="text-[#FF6BAA]">hard enough.</span>
          </h2>
          <p className="mt-4 text-base sm:text-lg max-w-md text-ink/70">
            Your shoes shouldn't be the thing you're thinking about six hours
            in.
          </p>
        </Reveal>

        <Reveal className="mt-7 -mx-4 sm:mx-0" delay={0.05}>
          <img
            data-testid="pain-image"
            src="/images/final-close.webp?v=2"
            alt="Three nurses in scrubs on a locker-room bench showing off pink, light blue and yellow POSSO clogs"
            className="w-full aspect-[1200/1499] object-cover block sm:rounded-3xl select-none"
            loading="lazy"
            draggable="false"
          />
        </Reveal>

        <div className="mt-7 space-y-3.5">
          {PAINS.map((p, i) => (
            <Reveal key={p} delay={i * 0.05}>
              <p
                data-testid={`pain-${i + 1}`}
                className="flex items-center gap-3 text-base sm:text-lg font-medium"
              >
                <span
                  className="w-3 h-3 rounded-full shrink-0 border border-ink/30"
                  style={{ backgroundColor: POGO_COLOURS[i % POGO_COLOURS.length].hex }}
                />
                {p}
              </p>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.15}>
          <p className="mt-9 text-base sm:text-lg max-w-md font-bold text-ink">
            Healthcare workers shouldn't have to choose between a shoe that
            handles the job and one they actually want to wear. POSSO brings
            both together.
          </p>
          <PreorderCta
            testId="pain-cta"
            origin="landing_pain"
            label="See how POSSO fixes this"
            variant="ghost"
            className="mt-5 text-ink"
          />
        </Reveal>
      </div>
    </section>
  );
}
